export enum AnimateType {
  negarate = 'negarate',
  geniusRate = 'geniusRate',
  default = 'default',
  favorite = 'favorite',
  poi = 'poi',
}
